<template>
  <div class="margin-top-medium width-100-pr">
    <div
      v-if="$utils.showNativePlayer(block.data.embed)"
      class="videoWrapper"
    >
      <video controls>
        <source
          :src="block.data.embed"
          type="video/mp4"
        >
        Su navegador no soporta la reproducción de este video.
      </video>
    </div>
    <div
      v-else
      class="iframeWrapper"
    >
      <iframe
        :src="block.data.embed"
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen
      >
      </iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeContentNodeBlockIframeVideo',

  props: {
    block: Object
  }
}
</script>
